// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { newsListContainerStyles } from "@conklin/App/Widgets/NewsList/NewsListContainer";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

newsListContainerStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        margin-bottom: 32px;
        ${xScreen("lte", "md")} {
            flex-direction: column-reverse;
            margin-bottom: 48px;
        }
    `,
};
newsListContainerStyles.content = {
    css: css`
        width: 75%;
        padding-left: 22px;
        ${xScreen("lte", "md")} {
            width: 100%;
            padding-left: 0;
            padding-bottom: 16px;
        }
    `,
};
newsListContainerStyles.sideBar = {
    css: css`
        width: 25%;
        height: fit-content;
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            width: 50%;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
newsListContainerStyles.filterWrapper = {
    css: css`
        width: 100%;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
